// Region (country) catalogue for the "Specify region" selector in the nav.
//
// `code` is the ISO 3166-1 alpha-2 country code TMDB keys `watch_providers` by
// (US, IN, GB, …). "WW" is our Worldwide sentinel — it means "no region bias":
// the API call omits the region and the "Watch on" badge falls back to US/first.
//
// The list is curated (not all ~190 TMDB regions) toward our audience + the
// regions with the best streaming-availability coverage in the catalogue
// (US ~52%, GB ~39%, CA/AU ~45%, IN ~22%, plus the user's target geos).
export const DEFAULT_REGION = 'WW';

export const REGIONS = [
  { code: 'WW', name: 'Worldwide', flag: '🌐' },
  { code: 'US', name: 'United States', flag: '🇺🇸' },
  { code: 'IN', name: 'India', flag: '🇮🇳' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
];

export const isWorldwide = (code) => !code || code === 'WW';

export const regionByCode = (code) => REGIONS.find((r) => r.code === code) || null;

// The value to send to the API: null for Worldwide (no region filter), else the
// country code. Keeps the "WW = no bias" contract in one place.
export const regionParam = (code) => (isWorldwide(code) ? null : code);

// Pick the watch_providers block to show the "Available on" badge for. Prefer the
// selected region; otherwise fall back to US, then the first region present —
// matching the prior US-first behaviour when no region is chosen.
export const pickProviderBlock = (watchProviders, region) => {
  if (!watchProviders || typeof watchProviders !== 'object') return null;
  if (!isWorldwide(region) && watchProviders[region]) return watchProviders[region];
  return watchProviders.US || watchProviders[Object.keys(watchProviders)[0]] || null;
};
